import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faUserDoctor,
  faLaptopCode,
} from "@fortawesome/free-solid-svg-icons";
import "./Services_Section.css";
import CommonHeading from "../../../New_Folder/Common_Components/Common_Heading/Common_Heading";
import { useNavigate } from "react-router-dom";

const servicesData = [
  {
    icon: faUsers,
    title: "Skilled Workers",
    description:
      "Connect with highly trained professionals in IT, engineering, construction, and trade skills.",
  },
  {
    icon: faUserDoctor,
    title: "Healthcare Professionals",
    description:
      "Registered nurses, doctors, and healthcare staff for hospitals and care facilities worldwide.",
  },
  {
    icon: faLaptopCode,
    title: "IT & BPO Professionals",
    description:
      "Top-tier software engineers, developers, and business process specialists for global tech companies.",
  },
];

export default function ServicesSection() {
  const navigate = useNavigate();

  return (
    <section className="services container">
      <Container>
        {/* <div className="services-header">
          <h2 className="services-title">Our Services</h2>

          <p className="services-subtitle">
            We provide comprehensive overseas recruitment solutions tailored to
            your needs
          </p>
        </div> */}

        <CommonHeading
          // badge="our achievements"
          title="Our Services"
          description="    We provide comprehensive overseas recruitment solutions tailored to
            your needs"
        />

        <Row className="g-4">
          {servicesData.map((service, index) => (
            <Col lg={4} md={6} sm={6} xs={12} key={index}>
              <div className="service-card">
                <div className="icon-wrapper">
                  <FontAwesomeIcon icon={service.icon} />
                </div>

                <h3 className="card-title">{service.title}</h3>

                <p className="card-description">{service.description}</p>
              </div>
            </Col>
          ))}
        </Row>

        <div className="button-wrapper">
          <button
            className="view-all-btn"
            onClick={() => navigate("/new/services")}
          >
            View All Services
          </button>
        </div>
      </Container>
    </section>
  );
}
